<template>
  <v-container id="page-driver-detail">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn class="mx-1" color="blue" outlined @click="onOpenUpdateDialog" iconName="mdi-pencil">수정
        </c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="onDeleteLostItem" iconName="delete">삭제</c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)"
               iconName="mdi-format-list-bulleted-square">
          돌아가기
        </c-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <c-card>
          <v-row justify="end" align="center" :class="contentReverse? 'd-flex flex-column-reverse' : ''">
            <v-col cols="9">
              <v-row align="center" class="pl-5">
                <v-col cols="12" sm="6" md="2">
                  <span>물품분류</span>
                </v-col>
                <v-col cols="12" sm="6" md="10">
                  <span class="black--text">{{lostItem? lostItem.type.configName: ''}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>습득 차량</span>
                </v-col>
                <v-col cols="12" sm="6" md="10">
                  <span class="black--text">{{lostItem? lostItem.vehicle: ''}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>습득 기사</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" >
                  <span style="cursor: pointer" @click="$router.push(`/drivers/${lostItem.driver.id}`)"  class="black--text">{{lostItem? lostItem.driver.name: ''}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>습득일</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" >
                  <span class="black--text">{{lostItem? lostItem.getDate: ''}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>분실물 요약</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" >
                  <span class="black--text">{{lostItem? lostItem.summary: '-'}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>분실물 상태</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" >
                  <span class="black--text">{{lostItem? lostItem.state.configName: ''}}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>분실물 상세</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" >
                  <span class="black--text">{{lostItem? lostItem.detail: '-'}}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" >
              <v-row justify="center" class="pr-sm-12 mr-md-3 mr-l g-1">
                <v-img @click="openImageDialog = true" v-if="lostItem && lostItem.photoUrl" :src="$func.getImgUrl(lostItem.photoUrl)" aspect-ratio="1" contain style="min-width: 400px; max-width:550px; margin-right: 150px; cursor: pointer"></v-img>
                <div v-else>
                  <v-icon size="100">camera</v-icon>
                </div>
              </v-row>
            </v-col>
            <v-dialog v-model="openImageDialog" max-width="60%">
              <div v-if="this.lostItem && this.lostItem.photoUrl">
                <v-img :src="$func.getImgUrl(this.lostItem.photoUrl)" style="background-color: white;"></v-img>
              </div>
            </v-dialog>
          </v-row>
        </c-card>
      </v-col>
    </v-row>

    <lost-item-c-u-dialog
      :open.sync="updateLostItemDialog"
      :lostItemFormData="lostItem"
      :driverList="driverList"
      @reqUpdateLostItem="reqUpdateLostItem"
    />
  </v-container>
</template>
<script>
  import LostItemCUDialog from "./LostItemCUDialog";

  export default {
    components: {LostItemCUDialog},
    data: () => ({
      lostItemId: null,
      lostItem: null,

      driverList: [], //분실물 등록 시 담당 기사 목록

      updateLostItemDialog: false,
      window: 0,
      contentReverse: false,

      openImageDialog: false,
    }),
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    methods: {
      handleResize() {
        if(window.innerWidth < 900) {
          this.contentReverse = true;
        } else {
          this.contentReverse = false;
        }
      },
      async reqGetLostItem() {
        try {
          const res = await this.$api.getLostItem(this.lostItemId);

          this.lostItem = res.data;
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqGetLostItem'});
        }
      },

      async reqGetDriverList() {
        try {
          const res = await this.$api.getDriverList();
          if(res && res.data)
            this.driverList = res.data.map(item => item.driver);

          return 1;
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqGetDriverList'});
          return 0;
        }
      },
      async reqUpdateLostItem(data) {
        try {
          const res = await this.$api.updateLostItem(data);
          this.lostItem = res.data;
          this.updateLostItemDialog = false;
          this.$store.commit('snackbar', {color:'blue', msg:'수정을 완료하였습니다.'});
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqUpdateLostItem'});
        }
      },
      async reqDeleteLostItem() {
        try {
          const res = await this.$api.deleteLostItem(this.lostItem.id);
          this.$store.commit('snackbar', {color:'blue', msg: '삭제가 완료되었습니다.'});
          this.$router.push('/lostItem');
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqDeleteLostItem'});
        }
      },

      async onOpenUpdateDialog() {
        if(await this.reqGetDriverList())
          this.updateLostItemDialog = true;
      },

      onDeleteLostItem() {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "분실물을 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteLostItem();
            }
          });
      },
    },
    mounted() {
      this.lostItemId = this.$route.params.lostItemId;
      this.reqGetLostItem();
    },
  }
</script>
<style lang="scss" scoped>
    .info-label {
        width: 100px;
    }
</style>
